export default "__VITE_ASSET__BLhHhcKl__"